<script>
  import DottedLine from '/components/Atoms/DottedLine'
  import Link from '/components/Atoms/Link'
  import { _ } from 'svelte-i18n'

  export let widgets

  const monthnames = [ $_("months.abbr.Jan"), $_("months.abbr.Feb"), $_("months.abbr.Mar"), $_("months.abbr.Apr"), $_("months.abbr.May"), $_("months.abbr.Jun"), $_("months.abbr.Jul"), $_("months.abbr.Aug"), $_("months.abbr.Sep"), $_("months.abbr.Oct"), $_("months.abbr.Nov"), $_("months.abbr.Dec") ]

  const items = widgets?.map( w => ({
    title: w.widgetText,
    people: w?.linkedContent?.[0]?.relatedPeople?.[0]?.members?.map( member => member.title) || [],
    link: w?.linkedContent?.[0]?.slug ? { slug: w?.linkedContent?.[0].slug, section: "almanac"} : null,
    type: w?.linkedContent?.[0]?.textMediaCategory || "",
    postDate: w.postDate
  }))

  const groupedItems = Object.values(items.reduce(function(groups, item) {
    const wDate = new Date(item.postDate)
    const year = wDate.getUTCFullYear()
    const month = wDate.getUTCMonth()
    const key = year+(month.toString().padStart(2, '0'))
    groups[key] = {
      month,
      year,
      items: [...(groups[key]?.items || []), item]
    };
    return groups;
  }, {}))
  //.sort( (g1, g2) => g1.month < g2.month)

  //console.log(widgets, items, groupedItems)
  //console.log(groupedItems)

</script>

{#if groupedItems.length > 0}

  <ol class="groups">
    {#each groupedItems as group}

    <li class="contents">
      <DottedLine>
        <span class="title" slot="left">
          {monthnames[group.month]}
        </span>
      </DottedLine>
    </li>

    <ul class="list">
      {#each group.items as item}
        <li class="item" class:large={item.large}>
          <Link stretch {...item.link}>
            {#if item.people.length > 0}

              <DottedLine>
                <span class="subtitle" slot="left">
                  <span class="title">
                    { item.title }
                  </span><br />
                  {#each item.people as person}
                    <span class="person">
                      {person}
                    </span>
                  {/each}
                </span>
                <span class="category" slot="right">
                  { item.type }
                </span>
              </DottedLine>

            {:else}

              <DottedLine>
                <span class="title" slot="left">
                  { item.title }
                </span>
                <span class="category" slot="right">
                  { item.type }
                </span>
              </DottedLine>

            {/if}
          </Link>
        </li>
      {/each}
    </ul>

    {/each}
  </ol>

{:else}

  <p class="noResults">
    No results found
  </p>

  {/if}

<style lang="scss">

  .contents {
    margin-top: 1em;
    @include grid-padding;
    margin-bottom: 60px;
    @include media-small {
      margin-bottom: 30px;
    }
    color: $color-red;
  }

  .list {
    @include grid-margin;
    padding-left: 60px;
    @include media-small {
      padding-left: 0;
    }
    padding-bottom: 1em;
  }

  .item {
    display: block;
    margin-bottom: 28px;
    position: relative;
  }

  .title, .subtitle, .category {
    background-color: $color-beige;
    position: relative;
    display: inline;
    z-index:1;
  }

  .title {
    @include typo-grotesk-title-30-small;
    position: relative;
    top: 0.12em;
  }

  .subtitle {
    @include typo-grotesk-text-24-small;

    .person {
      &:not(:last-child)::after {
        content: ", ";
        white-space: normal;
      }
      white-space: nowrap;
    }
  }

  .title, .subtitle {
    padding-right: .2em;
  }

  .category {
    @include typo-serif-small-caps-28-small;
    padding-left: .2em;
  }

  .noResults {
    @include grid-padding;
    @include typo-grotesk-text-24;
    color: $color-red;
    text-align: center;
    padding-block: 3em;
  }

</style>